import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { DatePipe } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  MatAutocomplete,
  MatAutocompleteSelectedEvent,
} from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { FilterViewModel } from 'src/app/core/models/regulation';

import { SelfAssessmentT2MasterFilter } from 'src/app/core/models/self-assessmentT2/self-assessmentT2-master-filter';
import {
  SelfAssessmentT3AllFilterDropdownDto,
  overallAssessmentDropdownList,
} from 'src/app/core/models/self-assessmentT3/overallDropdownList';
import { SelfAssessmentT3Filter } from 'src/app/core/models/self-assessmentT3/selft-assessmentT3-filter';
import { GlobalService } from 'src/app/core/services/global/global.service';
import { GDPRService } from 'src/app/core/services/rulebook';
import { SelfAssessmentTemplate3Service } from 'src/app/core/services/self-assessment-template3/self-assessment-template3.service';
import { MasterHelper } from 'src/app/core/utilities';

@Component({
  selector: 'app-self-assessment-t3-filter',
  templateUrl: './self-assessment-t3-filter.component.html',
  styleUrls: ['./self-assessment-t3-filter.component.scss'],
})
export class SelfAssessmentT3FilterComponent {
  @Output() OnFilterT3 = new EventEmitter<SelfAssessmentT3Filter>();
  @ViewChild('keywordInput') keywordInput!: ElementRef<HTMLInputElement>;
  @ViewChild('autoKeyword') autoKeyword!: MatAutocomplete;
  filterT3PersistenceKey = 'selfAssessmentT3Filters';
  SelfAssessmentT3FilterModel: SelfAssessmentT3Filter =
    new SelfAssessmentT3Filter();
  masterT3Filters: SelfAssessmentT2MasterFilter =
    new SelfAssessmentT2MasterFilter();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  isPersistFilter = false;
  filteredKeywords: string[] = [];
  visible = true;
  selectable = true;
  removable = true;
  overallAssessmentDropdownList!: SelfAssessmentT3AllFilterDropdownDto;
  addOnBlur = true;
  keyCtrl = new FormControl();
  isLoadingFilters = false;
  oldestCreationDate: string = MasterHelper.getDateStr(30);

  constructor(
    private gdprService: GDPRService,
    private _selfAssessmentT3Service: SelfAssessmentTemplate3Service,
    private datePipe: DatePipe,
    public _globalService: GlobalService
  ) {
    const persistFilter = JSON.parse(
      this.fetchFromBrowser() as string
    ) as SelfAssessmentT3Filter;
    if (persistFilter) {
      this.SelfAssessmentT3FilterModel = persistFilter;
      this.isPersistFilter = true;
    }
    this.filteredKeywords = [];
  }

  ngOnInit() {
    if (!this.isPersistFilter) {
      this.SelfAssessmentT3FilterModel = new SelfAssessmentT3Filter();
    }
    this.getSAT3FilterAllDropDowns();
  }

  async getSAT3FilterAllDropDowns() {
    let userProfile = await this._globalService.getLoginUserData();
    this._selfAssessmentT3Service
      .getT3OverAllAssessmentDropdownFilter(userProfile.lastUsedJurisdictionId)
      .subscribe((res: SelfAssessmentT3AllFilterDropdownDto) => {
        this.overallAssessmentDropdownList = res;
        this.ownerList = this.overallAssessmentDropdownList.ruleOwner;
        this.searchedOwner = this.ownerList;
        this.ownerFilterList = this.SelfAssessmentT3FilterModel.owner;
        this.searchOWCntrl.valueChanges.subscribe((term: any) => {
          this.searchedOwner = term
            ? this.filterOwnerName(term)
            : this.searchedOwner;
        });

        //Assessor List
        this.assessorList = this.overallAssessmentDropdownList.ruleOwner;
        this.searchedAssessor = this.assessorList;
        this.assessorFilterList = this.SelfAssessmentT3FilterModel.assessor;
        this.searchAssessorCntrl.valueChanges.subscribe((term: any) => {
          this.searchedAssessor = term
            ? this.filterAssessorName(term)
            : this.searchedAssessor;
        });
        //this.startOwFilterDropdownFieldFn();
        this.csList = this.overallAssessmentDropdownList.complianceStatus;
        this.searchedCS = this.csList;
        this.csFilterList = this.SelfAssessmentT3FilterModel.complianceStatus;
        this.searchCSCntrl.valueChanges.subscribe((term: any) => {
          this.searchedCS = term ? this.filterCsName(term) : this.searchedCS;
        });
        //this.startCsFilterDropdownFieldFn();
        this.asList = this.overallAssessmentDropdownList.assessmentStatus;
        this.searchedAS = this.asList;
        this.asFilterList = this.SelfAssessmentT3FilterModel.assessmentStatus;
        this.searchASCntrl.valueChanges.subscribe((term: any) => {
          this.searchedAS = term ? this.filterAsName(term) : this.searchedAS;
        });
        //this.startAsFilterDropdownFieldFn();
        this.SelfAssessmentT3FilterModel.fromDate = this
          .SelfAssessmentT3FilterModel.fromDate
          ? this.datePipe.transform(
            this.SelfAssessmentT3FilterModel.fromDate,
            'yyyy-MM-dd'
          )!
          : res.fromDate;
      });
  }

  initFilters(): void {
    this.SelfAssessmentT3FilterModel = new SelfAssessmentT3Filter();
    // this.searchedOwner = this.masterT3Filters.owner;
    // this.searchedAT = this.masterT3Filters.assessmentTeam;
    // this.searchedAS = this.masterT3Filters.assessmentStatus;
    // this.searchedCS = this.masterT3Filters.complianceStatus;
    // this.searchedRT = this.masterT3Filters.reviewerTeam;
    // this.searchedRS = this.masterT3Filters.reviewStatus;
    // this.searchedIP = this.masterT3Filters.interpretation;
    // this.searchedDJ = this.masterT3Filters.judgement;
    // this.searchedCG = this.masterT3Filters.gaps;
    // this.searchedEN = this.masterT3Filters.enhancement;
    // this.searchedAPT = this.masterT3Filters.approvalTeam;
    // this.searchedAPS = this.masterT3Filters.approvalStatus;
    // this.SelfAssessmentT3FilterModel.fromDate = this.datePipe.transform(
    //   this.SelfAssessmentT3FilterModel.fromDate,
    //   'yyyy-MM-dd'
    // )!;
    // this.SelfAssessmentT3FilterModel.toDate = this.datePipe.transform(
    //   this.SelfAssessmentT3FilterModel.toDate,
    //   'yyyy-MM-dd'
    // )!;
    this.saveOnBrowser(JSON.stringify(this.SelfAssessmentT3FilterModel));
    // this.OnFilterT3.emit(this.SelfAssessmentT3FilterModel);
  }
  resetFilters(): void {
    this.SelfAssessmentT3FilterModel = new SelfAssessmentT3Filter();
    this.getSAT3FilterAllDropDowns();
    this.SelfAssessmentT3FilterModel.ruleBook = [];
    this.SelfAssessmentT3FilterModel.part = [];
    this.SelfAssessmentT3FilterModel.owner = [];
    this.SelfAssessmentT3FilterModel.assessor =[];
    this.SelfAssessmentT3FilterModel.regulatoryRuleFullRequirement = [];
    this.SelfAssessmentT3FilterModel.assessmentTeam = [];
    this.SelfAssessmentT3FilterModel.assessmentDetails = [];
    this.SelfAssessmentT3FilterModel.assessmentStatus = [];
    this.SelfAssessmentT3FilterModel.complianceStatus = [];
    this.SelfAssessmentT3FilterModel.searchQuery = [];
    this.searchedOwner = this.masterT3Filters.owner;
    // this.searchedAT = this.masterT3Filters.assessmentTeam;
    // this.searchedAS = this.masterT3Filters.assessmentStatus;
    // this.searchedCS = this.masterT3Filters.complianceStatus;
    // this.searchedRT = this.masterT3Filters.reviewerTeam;
    // this.searchedRS = this.masterT3Filters.reviewStatus;
    // this.searchedIP = this.masterT3Filters.interpretation;
    // this.searchedDJ = this.masterT3Filters.judgement;
    // this.searchedCG = this.masterT3Filters.gaps;
    // this.searchedEN = this.masterT3Filters.enhancement;
    // this.searchedAPT = this.masterT3Filters.approvalTeam;
    // this.searchedAPS = this.masterT3Filters.approvalStatus;
    this.SelfAssessmentT3FilterModel.fromDate = this.datePipe.transform(
      this.SelfAssessmentT3FilterModel.fromDate,
      'yyyy-MM-dd'
    )!;
    this.SelfAssessmentT3FilterModel.toDate = this.datePipe.transform(
      this.SelfAssessmentT3FilterModel.toDate,
      'yyyy-MM-dd'
    )!;
    this.saveOnBrowser(JSON.stringify(this.SelfAssessmentT3FilterModel));
    this.OnFilterT3.emit(this.SelfAssessmentT3FilterModel);
  }
  submitAction(): void {
    this.SelfAssessmentT3FilterModel.fromDate = this.datePipe.transform(
      this.SelfAssessmentT3FilterModel.fromDate,
      'yyyy-MM-dd'
    )!;
    this.SelfAssessmentT3FilterModel.toDate = this.datePipe.transform(
      this.SelfAssessmentT3FilterModel.toDate,
      'yyyy-MM-dd'
    )!;
    this.SelfAssessmentT3FilterModel.nextassessmentDue =
      this.datePipe.transform(
        this.SelfAssessmentT3FilterModel.nextassessmentDue,
        'yyyy-MM-dd'
      )!;
    this.SelfAssessmentT3FilterModel.reviewDate = this.datePipe.transform(
      this.SelfAssessmentT3FilterModel.reviewDate,
      'yyyy-MM-dd'
    )!;
    this.saveOnBrowser(JSON.stringify(this.SelfAssessmentT3FilterModel));
    this.OnFilterT3.emit(this.SelfAssessmentT3FilterModel);
  }
  saveOnBrowser(value: string) {
    localStorage.setItem(this.filterT3PersistenceKey, value);
  }
  fetchFromBrowser() {
    return localStorage.getItem(this.filterT3PersistenceKey);
  }
  // Owner Events
  ownerFilterList!: string[];
  @ViewChild('oWInput')
  oWInput!: ElementRef<HTMLInputElement>;
  @ViewChild('oWAutocomplete')
  oWAutocomplete!: MatAutocomplete;
  searchOWCntrl: FormControl = new FormControl();
  searchedOwner: FilterViewModel[] = [];
  ownerList: FilterViewModel[] = [];
  
  filterOwnerName(search: string) {
    return this.ownerList.filter((option) =>
      option.value.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterOwWithoutSelectedItem() {
    if (this.ownerFilterList && this.ownerFilterList.length > 0) {
      this.searchedOwner = this.ownerList.filter(
        (obj: FilterViewModel) => !this.ownerFilterList.includes(obj.name)
      );
    } else {
      this.searchedOwner = this.ownerList;
    }
  }
  addOW(event: MatChipInputEvent) {
    const value = event.value;
    if (!this.oWAutocomplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.ownerFilterList?.find(
          (option: string) => option == value
        );
        if (sameValueRow?.length == 0 || !sameValueRow) {
          this.ownerFilterList.push(value);
        }
      }
      this.filterOwWithoutSelectedItem();
      event.chipInput!.clear();
      this.searchOWCntrl.setValue(null);
      this.searchOWCntrl.disable();
      this.searchOWCntrl.enable();
    }
  }
  selectedOWEvent(event: MatAutocompleteSelectedEvent) {
    if (this.ownerFilterList) {
      let sameValueRow = this.ownerFilterList.filter(
        (option: string) => option == event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.addOwnerFilterListFn(event.option.viewValue);
      }
    } else {
      this.ownerFilterList = [];
      this.addOwnerFilterListFn(event.option.viewValue);
    }
    if (this.oWInput) {
      this.oWInput.nativeElement.value = '';
    }
    this.searchOWCntrl.setValue(null);
    this.searchOWCntrl.disable();
    this.searchOWCntrl.enable();
    this.filterOwWithoutSelectedItem();
  }
  addOwnerFilterListFn(matchString: string) {
    let selectedValue: FilterViewModel | undefined = this.ownerList.find(
      (option) => option.name == matchString
    );
    if (selectedValue) {
      this.ownerFilterList.push(selectedValue.name);
    }
  }
  removeOW(value: string) {
    if (this.ownerFilterList && this.ownerFilterList.length > 0) {
      const index = this.ownerFilterList.findIndex(
        (obj: string) => obj == value
      );
      if (index >= 0) {
        this.ownerFilterList.splice(index, 1);
      }
      this.filterOwWithoutSelectedItem();
    }
  }
  // compliance status Events
  csFilterList!: string[];
  @ViewChild('cSInput')
  cSInput!: ElementRef<HTMLInputElement>;
  @ViewChild('cSAutocomplete')
  cSAutocomplete!: MatAutocomplete;
  searchCSCntrl: FormControl = new FormControl();
  searchedCS: string[] = [];
  csList: string[] = [];
 
  filterCsName(search: string) {
    return this.csList.filter((option) =>
      option.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterCsWithoutSelectedItem() {
    if (this.csFilterList && this.csFilterList.length > 0) {
      this.searchedCS = this.csList.filter(
        (obj: string) => !this.csFilterList.includes(obj)
      );
    } else {
      this.searchedCS = this.csList;
    }
  }
  addCS(event: MatChipInputEvent): void {
    if (!this.cSAutocomplete.isOpen) {
      const value = event.value;
      this.filterCsWithoutSelectedItem();
      event.chipInput!.clear();
      this.searchCSCntrl.setValue(null);
    }
  }
  selectedCSEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.csFilterList) {
      let sameValueRow = this.csFilterList.filter(
        (option: string) => option == event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.addCsFilterListFn(event.option.viewValue);
      }
    } else {
      this.csFilterList = [];
      this.addCsFilterListFn(event.option.viewValue);
    }
    if (this.cSInput) {
      this.cSInput.nativeElement.value = '';
    }
    this.searchCSCntrl.setValue(null);
    this.searchCSCntrl.disable();
    this.searchCSCntrl.enable();
    this.filterCsWithoutSelectedItem();
  }
  addCsFilterListFn(matchString: string) {
    let selectedValue: string | undefined = this.csList.find(
      (option) => option == matchString
    );
    if (selectedValue) {
      this.csFilterList.push(selectedValue);
    }
  }
  removeCS(value: string): void {
    if (this.csFilterList && this.csFilterList.length > 0) {
      const index = this.csFilterList.findIndex((obj: string) => obj == value);
      if (index >= 0) {
        this.csFilterList.splice(index, 1);
      }
      this.filterCsWithoutSelectedItem();
    }
  }
  //Assessment Status
  asFilterList!: string[];
  @ViewChild('aSInput')
  aSInput!: ElementRef<HTMLInputElement>;
  @ViewChild('aSAutocomplete')
  aSAutocomplete!: MatAutocomplete;
  searchASCntrl: FormControl = new FormControl();
  searchedAS: string[] = [];
  asList: string[] = [];
  
  filterAsName(search: string) {
    return this.asList.filter((option) =>
      option.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterAsWithoutSelectedItem() {
    if (this.asFilterList && this.asFilterList.length > 0) {
      this.searchedAS = this.asList.filter(
        (obj: string) => !this.asFilterList.includes(obj)
      );
    } else {
      this.searchedAS = this.asList;
    }
  }
  addAS(event: MatChipInputEvent): void {
    if (!this.aSAutocomplete.isOpen) {
      const value = event.value;
      this.filterAsWithoutSelectedItem();
      event.chipInput!.clear();
      this.searchASCntrl.setValue(null);
    }
  }
  selectedASEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.asFilterList) {
      let sameValueRow = this.asFilterList.filter(
        (option: string) => option == event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.addAsFilterListFn(event.option.viewValue);
      }
    } else {
      this.asFilterList = [];
      this.addAsFilterListFn(event.option.viewValue);
    }
    if (this.aSInput) {
      this.aSInput.nativeElement.value = '';
    }
    this.searchASCntrl.setValue(null);
    this.searchASCntrl.disable();
    this.searchASCntrl.enable();
    this.filterAsWithoutSelectedItem();
  }
  addAsFilterListFn(matchString: string) {
    let selectedValue: string | undefined = this.asList.find(
      (option) => option == matchString
    );
    if (selectedValue) {
      this.asFilterList.push(selectedValue);
    }
  }
  removeAS(value: string): void {
    if (this.asFilterList && this.asFilterList.length > 0) {
      const index = this.asFilterList.findIndex((obj: string) => obj == value);
      if (index >= 0) {
        this.asFilterList.splice(index, 1);
      }
      this.filterAsWithoutSelectedItem();
    }
  }

  addRuleId(event: MatChipInputEvent): void {
    const value = event.value;
    if ((value || '').trim()) {
      this.SelfAssessmentT3FilterModel.ruleId.push(value.trim());
    }
    event.chipInput!.clear();
  }

  removeRuleId(type: string): void {
    const index = this.SelfAssessmentT3FilterModel.ruleId.indexOf(type);
    if (index >= 0) {
      this.SelfAssessmentT3FilterModel.ruleId.splice(index, 1);
    }
  }

  addRulebookRuleId(event: MatChipInputEvent): void {
    const value = event.value;
    if ((value || '').trim()) {
      this.SelfAssessmentT3FilterModel.rulebookRuleId.push(value.trim());
    }
    event.chipInput!.clear();
  }

  removeRulebookRuleId(type: string): void {
    const index = this.SelfAssessmentT3FilterModel.rulebookRuleId.indexOf(type);
    if (index >= 0) {
      this.SelfAssessmentT3FilterModel.rulebookRuleId.splice(index, 1);
    }
  }


  // Assessor Events
  assessorFilterList!: string[];
  @ViewChild('assessorInput')
  assessorInput!: ElementRef<HTMLInputElement>;
  @ViewChild('assessorAutocomplete')
  assessorAutocomplete!: MatAutocomplete;
  searchAssessorCntrl: FormControl = new FormControl();
  searchedAssessor: FilterViewModel[] = [];
  assessorList: FilterViewModel[] = [];
  
  filterAssessorName(search: string) {
    return this.assessorList.filter((option) =>
      option.value.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterAssessorWithoutSelectedItem() {
    if (this.assessorFilterList && this.assessorFilterList.length > 0) {
      this.searchedAssessor = this.assessorList.filter(
        (obj: FilterViewModel) => !this.assessorFilterList.includes(obj.name)
      );
    } else {
      this.searchedAssessor = this.assessorList;
    }
  }
  addAssessor(event: MatChipInputEvent) {
    const value = event.value;
    if (!this.assessorAutocomplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.assessorFilterList?.find(
          (option: string) => option == value
        );
        if (sameValueRow?.length == 0 || !sameValueRow) {
          this.assessorFilterList.push(value);
        }
      }
      this.filterAssessorWithoutSelectedItem();
      event.chipInput!.clear();
      this.searchAssessorCntrl.setValue(null);
      this.searchAssessorCntrl.disable();
      this.searchAssessorCntrl.enable();
    }
  }
  selectedAssessorEvent(event: MatAutocompleteSelectedEvent) {
    if (this.assessorFilterList) {
      let sameValueRow = this.assessorFilterList.filter(
        (option: string) => option == event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.addAssessorFilterListFn(event.option.viewValue);
      }
    } else {
      this.assessorFilterList = [];
      this.addAssessorFilterListFn(event.option.viewValue);
    }
    if (this.assessorInput) {
      this.assessorInput.nativeElement.value = '';
    }
    this.searchAssessorCntrl.setValue(null);
    this.searchAssessorCntrl.disable();
    this.searchAssessorCntrl.enable();
    this.filterAssessorWithoutSelectedItem();
  }
  addAssessorFilterListFn(matchString: string) {
    let selectedValue: FilterViewModel | undefined = this.ownerList.find(
      (option) => option.name == matchString
    );
    if (selectedValue) {
      this.assessorFilterList.push(selectedValue.name);
    }
  }
  removeAssessor(value: string) {
    if (this.assessorFilterList && this.assessorFilterList.length > 0) {
      const index = this.assessorFilterList.findIndex(
        (obj: string) => obj == value
      );
      if (index >= 0) {
        this.assessorFilterList.splice(index, 1);
      }
      this.filterAssessorWithoutSelectedItem();
    }
  }
}
